import { cn } from '@/lib/utils';
import { FISCAL_STATUS_LABEL, type FiscalStatus } from '@/features/fiscal/schemas';

const STATUS_CLASSES: Record<FiscalStatus, string> = {
  AWAITING_REPORT: 'bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-200',
  IN_REVIEW: 'bg-sky-100 text-sky-900 dark:bg-sky-900/40 dark:text-sky-200',
  MATCHED: 'bg-emerald-100 text-emerald-900 dark:bg-emerald-900/40 dark:text-emerald-200',
  DIVERGENT: 'bg-red-100 text-red-900 dark:bg-red-900/40 dark:text-red-200',
  NFSE_EMITTED: 'bg-indigo-100 text-indigo-900 dark:bg-indigo-900/40 dark:text-indigo-200',
  NFSE_SENT: 'bg-violet-100 text-violet-900 dark:bg-violet-900/40 dark:text-violet-200',
  PAID: 'bg-teal-100 text-teal-900 dark:bg-teal-900/40 dark:text-teal-200',
  CANCELED: 'bg-zinc-200 text-zinc-800 dark:bg-zinc-800 dark:text-zinc-200',
};

interface Props {
  status: FiscalStatus;
  className?: string;
}

export function FiscalStatusBadge({ status, className }: Props) {
  return (
    <span
      data-status={status}
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        STATUS_CLASSES[status],
        className,
      )}
    >
      {FISCAL_STATUS_LABEL[status]}
    </span>
  );
}
